import { useState } from 'react';
export function useIndexedData(data, createNewData) {
    const initialIndexedData = data.map((d, index) => ({ index, data: d }));
    const initialData = {
        indexedData: initialIndexedData,
        nextIndex: initialIndexedData.length,
    };
    const [indexedDataProps, setIndexedDataProps] = useState(initialData);
    const updateData = (index, d) => setIndexedDataProps((indexedDataProps) => {
        const dataIndex = indexedDataProps.indexedData.findIndex((a) => a.index === index);
        const updatedIndexedData = indexedDataProps.indexedData.map((indexedData, i) => i === dataIndex ? { ...indexedData, data: d } : indexedData);
        return {
            ...indexedDataProps,
            indexedData: updatedIndexedData,
        };
    });
    const deleteData = (index) => setIndexedDataProps((indexedDataProps) => ({
        ...indexedDataProps,
        indexedData: indexedDataProps.indexedData.filter((a) => a.index !== index),
    }));
    const addData = () => setIndexedDataProps((indexedDataProps) => ({
        ...indexedDataProps,
        indexedData: [
            ...indexedDataProps.indexedData,
            {
                index: indexedDataProps.nextIndex,
                data: createNewData(),
            },
        ],
        nextIndex: indexedDataProps.nextIndex + 1,
    }));
    return [indexedDataProps.indexedData, updateData, deleteData, addData];
}
//# sourceMappingURL=IndexedData.js.map